import { render, staticRenderFns } from "./ServicesCatalogue.vue?vue&type=template&id=3684844c"
import script from "./ServicesCatalogue.vue?vue&type=script&lang=ts"
export * from "./ServicesCatalogue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports